import { render, staticRenderFns } from "./first-order-reward.vue?vue&type=template&id=3a38e58e&"
import script from "./first-order-reward.vue?vue&type=script&lang=js&"
export * from "./first-order-reward.vue?vue&type=script&lang=js&"
import style0 from "./first-order-reward.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports